import {Form} from '@mintdata-wsp/common/components/form/Form';
import {IFormFieldState} from '@mintdata-wsp/common/components/formField/FormField';
import {Validators} from '@mintdata-wsp/common/components/validators/Validators';
import {ApiError} from '@mintdata-wsp/common/controllers/network/Fetcher';
import {JoinRegisteredRequest} from '@mintdata-wsp/common/controllers/network/generated/requests/JoinRegisteredRequest';
import {JoinRequest} from '@mintdata-wsp/common/controllers/network/generated/requests/JoinRequest';
import {CheckInviteCodeResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/CheckInviteCodeResponse';
import {Response} from '@mintdata-wsp/common/controllers/network/generated/responses/Response';
import {AnalyticsEventActions} from '@mintdata-wsp/common/controllers/analytics/AnalyticsEventActions';
import {rootState, UserSessionState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {action} from 'mobx';
const md5 = require('md5');

export class JoinController
{
    public init()
    {
    }

    @action.bound
    public setJoinOrganization()
    {
        rootState.ui.joinPage.joinOrganization = true;
    }

    @action.bound
    public setInviteCode(inviteCode:string)
    {
        rootState.ui.joinPage.inviteCode = inviteCode;
    }

    @action.bound
    public checkInviteCode():Promise<any>
    {
        const {joinPage} = rootState.ui;

        if( joinPage.isInviteCodeChecked ) return;

        joinPage.isCheckInviteCodeInProgress = true;

        // TODO remove debug ------------------------------
        // setTimeout(action(()=>{
        //     joinPage.isInviteCodeChecked = true;
        //     joinPage.isCheckInviteCodeInProgress = false;
        //     joinPage.isInviteCodeValid = false;
        // }), 4000);
        // return
        // TODO remove debug ------------------------------

        return controllers.net.invite.checkInviteCode(joinPage.inviteCode)
            .then(action((response:CheckInviteCodeResponse | ApiError) =>
            {
                if( ApiError.isError(response) )
                {
                    throw (response as ApiError).message;
                }
                else
                {
                    // TODO remove debug ------------------------------
                    // setTimeout(action(()=>{

                    joinPage.isInviteCodeChecked = true;
                    joinPage.isCheckInviteCodeInProgress = false;
                    joinPage.isInviteCodeValid = (response as CheckInviteCodeResponse).allowed;
                    joinPage.checkInviteCodeResponse = response as CheckInviteCodeResponse;

                    // TODO remove debug ------------------------------
                    // }), 4000);
                }
            }))
            .catch(action((message:string | any) =>
            {
                // TODO remove debug ------------------------------
                // setTimeout(action(()=>{

                console.warn(message);

                joinPage.isInviteCodeChecked = true;
                joinPage.isCheckInviteCodeInProgress = false;
                joinPage.isInviteCodeValid = false;

                // TODO remove debug ------------------------------
                // }), 4000);
            }));
    }

    @action.bound
    public requestInvitationResend()
    {
        const {joinPage} = rootState.ui;

        joinPage.isInvitationResentError = false;
        joinPage.isInvitationResentInProgress = true;

        // TODO remove debug ------------------------------
        // setTimeout(action(()=>{
        //     joinPage.isInvitationResentError = true;
        //     joinPage.isInvitationResentInProgress = false;
        // }), 14000);
        // return;
        // TODO remove debug ------------------------------

        controllers.net.invite.requestInvitationResend(joinPage.inviteCode)
            .then(action((response:Response | ApiError) =>
            {
                if( ApiError.isError(response) )
                {
                    throw (response as ApiError).message;
                }
                else
                {
                    // TODO remove debug ------------------------------
                    // setTimeout(action(()=>{

                    joinPage.isInvitationResent = true;
                    joinPage.isInvitationResentInProgress = false;

                    // TODO remove debug ------------------------------
                    // }), 4000);
                }
            }))
            .catch(action((message:string | any) =>
            {
                // TODO remove debug ------------------------------
                // setTimeout(action(()=>{

                console.warn(message);

                joinPage.isInvitationResentError = true;
                joinPage.isInvitationResentInProgress = false;

                // TODO remove debug ------------------------------
                // }), 4000);
            }));
    }

    @action
    public submitForm(form:Form)
    {
        const {joinPage} = rootState.ui;
        const {joinOrganization} = joinPage;

        if( !joinOrganization &&
            (joinPage.isJoinInProgress || !form.areAllFieldsValid() || form.areSomeFieldIsEmpty() || !joinPage.checkInviteCodeResponse)
        )
            return;

        form.removeServerErrors();
        joinPage.isJoinInProgress = true;

        const {inviteCode} = joinPage;

        let joinRequest = null;

        if( joinOrganization )
        {
            const req = new JoinRegisteredRequest(inviteCode);

            joinRequest = controllers.user.joinRegistered(req);
        }
        else
        {
            let formData = form.getFormData();

            const fullName:string = formData.fullName as string;
            const password:string = formData.password as string;

            const {email} = joinPage.checkInviteCodeResponse;

            const req = new JoinRequest(inviteCode,
                fullName,
                email.replace('@', '_'),
                md5(password),
                email);

            joinRequest = controllers.user.join(req);
        }

        // TODO remove debug ------------------------------
        // setTimeout(action(()=>{
        //     joinPage.isJoinInProgress = false;
        //     form.setServerErrors('error from server');
        // }), 4000);
        // return ;
        // TODO remove debug ------------------------------

        joinRequest
            .then(action((response:UserSessionState | ApiError) =>
            {
                if( ApiError.isError(response) )
                {
                    throw (response as ApiError).message;
                }
                joinPage.isJoinInProgress = false;

                const {currentUser, currentOrganization} = response as UserSessionState;

                controllers.analytics.main.trackEvent(
                    AnalyticsEventActions.WSP_INVITE_NEW_USER_CONFIRMED_ORG,
                    {
                        user_guid: currentUser.uuid,
                        user_email: currentUser.email,

                        org_sid: currentOrganization.siteId,
                        org_name: currentOrganization.name,

                        is_user_has_wsp_account: joinOrganization,
                    }
                );

                controllers.navigation.toAppHome();
            }))
            .catch(action((err:string | any) =>
            {
                console.warn(err);
                joinPage.isJoinInProgress = false;

                let message:string = '';

                if( ApiError.isError(err) )
                    message = (err as ApiError).message;
                else
                    message = err;

                if( message )
                {
                    if( joinOrganization )
                    {
                        joinPage.isInviteCodeChecked = true;
                        joinPage.isCheckInviteCodeInProgress = false;
                        joinPage.isInviteCodeValid = false;
                    }
                    else
                        form.setServerErrors(message);
                }
            }));
    }

    public validateFullName(value:string, state:IFormFieldState<string>, form?:Form)
    {
        return Validators.validate({value, state, form, errorMessage: 'Please enter your name'},
            [
                Validators.serverError('fullname'),
                Validators.emptyNotDirtyIsValid(),
                Validators.required(),
                Validators.minLength(1),
                Validators.maxLength(255)
            ]);
    }

    public validatePassword(value:string, state:IFormFieldState<string>, form?:Form)
    {
        return Validators.validate({value, state, form},
            [
                Validators.serverError('password'),
                Validators.emptyNotDirtyIsValid(),
                Validators.password()
            ]);
    }
}
